import { Card, CardContent, IconButton, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import AppHeader from "@saleor/components/AppHeader";
import CardTitle from "@saleor/components/CardTitle";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import Grid from "@saleor/components/Grid";
import PageHeader from "@saleor/components/PageHeader";
import { InsCommentDetail_commentById } from "@saleor/inscomment/types/InsCommentDetail";
import { commonMessages, sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import moment from "moment-timezone";
import React from "react";
import { useIntl } from "react-intl";

import { FormData } from "../InsCommentHistory";
import InsCommentHistory from "../InsCommentHistory";
export interface InsCommentDetailsPageProps {
  insComment: InsCommentDetail_commentById;
  disabled: boolean;
  btnIsVisible: () => void;
  btnComment: (data: FormData) => void;
  onBack: () => void;
}
const useStyles = makeStyles(
  theme => ({
    image: {
      height: "500px",
      // objectFit: "contain",
      // userSelect: "none",
      width: "100%"
    },
    root: {
      display: "flex",
      justifyContent: "center",
      gridColumnGap: theme.spacing(2),
      gridRowGap: theme.spacing(2),
      gridTemplateColumns: "repeat(4, 1fr)",
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "repeat(3, 1fr)"
      },
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "repeat(2, 1fr)"
      }
    }
  }),
  { name: "ProductImages" }
);
const InsCommentDetailsPage: React.FC<InsCommentDetailsPageProps> = ({
  insComment,
  btnIsVisible,
  btnComment,
  onBack
}) => {
  const intl = useIntl();
  const initialForm = {
    userName: maybe(() => insComment.userName, ""),
    text: maybe(() => insComment.text, ""),
    created: maybe(
      () => moment(insComment.created).format("YYYY-MM-DD HH:mm:ss"),
      ""
    ),
    source: maybe(() => insComment.source, ""),
    parentType: maybe(() => insComment.parentType, ""),
    parentMedia: maybe(() => insComment.parentMedia, null),
    parentComment: maybe(() => insComment.parentComment, null),
    isVisible: maybe(() => insComment.isVisible, true)
  };
  const classes = useStyles();
  return (
    <Form initial={initialForm} onSubmit={undefined}>
      {({ data }) => (
        <Container>
          <div
            style={{
              position: "absolute"
            }}
          >
            <AppHeader onBack={onBack}>
              {intl.formatMessage(sectionNames.commentList)}
            </AppHeader>
            <IconButton
              style={{
                position: "relative",
                left: 250,
                top: -15
              }}
              color="primary"
              onClick={() => {
                btnIsVisible();
              }}
            >
              {data.isVisible ? (
                <VisibilityIcon color={"primary"} fontSize={"large"} />
              ) : (
                <VisibilityOffIcon color={"inherit"} fontSize={"large"} />
              )}
            </IconButton>
          </div>
          <PageHeader
            title={intl.formatMessage({
              defaultMessage: "InsComment Details",
              description: "InsComment Details"
            })}
          />
          <Grid>
            <Card>
              <CardTitle
                title={intl.formatMessage(commonMessages.generalInformations)}
              ></CardTitle>
              <CardContent>
                <TextField
                  disabled={true}
                  label={intl.formatMessage({
                    defaultMessage: "User Name",
                    description: "User Name"
                  })}
                  fullWidth
                  value={data.userName}
                />
                <FormSpacer />
                <TextField
                  disabled={true}
                  label={intl.formatMessage({
                    defaultMessage: "Comment Text",
                    description: "Comment Text"
                  })}
                  fullWidth
                  multiline
                  rowsMax={10}
                  value={data.text}
                />
                <FormSpacer />
                <TextField
                  disabled={true}
                  label={intl.formatMessage({
                    defaultMessage: "Created Time",
                    description: "Created Time"
                  })}
                  fullWidth
                  value={data.created}
                />
                <FormSpacer />
                <TextField
                  disabled={true}
                  label={intl.formatMessage({
                    defaultMessage: "Source",
                    description: "source"
                  })}
                  fullWidth
                  value={data.source}
                />
              </CardContent>
            </Card>
            <FormSpacer />
            {data?.parentMedia && (
              <Card>
                <CardTitle
                  title={intl.formatMessage({
                    defaultMessage: "Parent Media",
                    description: "Parent Media"
                  })}
                ></CardTitle>
                <CardContent>
                  <div className={classes.root}>
                    <div>
                      {insComment?.parentMedia.mimeType === "image/jpeg" && (
                        <img
                          className={classes.image}
                          src={data.parentMedia.image}
                        />
                      )}
                      {insComment?.parentMedia.mimeType === "video/mp4" && (
                        <video controls={true} className={classes.image}>
                          <source
                            className={classes.image}
                            src={data.parentMedia.image}
                          ></source>
                        </video>
                      )}
                    </div>
                  </div>
                  <FormSpacer />
                  <TextField
                    disabled={true}
                    label={intl.formatMessage({
                      defaultMessage: "User Name",
                      description: "User Name"
                    })}
                    fullWidth
                    value={data.parentMedia.username}
                  />
                  <FormSpacer />
                  <TextField
                    disabled={true}
                    label={intl.formatMessage({
                      defaultMessage: "Parent Content",
                      description: "Parent Content"
                    })}
                    fullWidth
                    multiline
                    rows={10}
                    value={data.parentMedia.titokDesc}
                  />
                  <FormSpacer />
                </CardContent>
              </Card>
            )}
            {data?.parentComment && (
              <Card>
                <CardTitle
                  title={intl.formatMessage({
                    defaultMessage: "Parent Comment",
                    description: "Parent Comment"
                  })}
                ></CardTitle>
                <CardContent>
                  <TextField
                    disabled={true}
                    label={intl.formatMessage({
                      defaultMessage: "User Name",
                      description: "User Name"
                    })}
                    fullWidth
                    value={data.parentComment.userName}
                  />
                  <FormSpacer />
                  <TextField
                    disabled={true}
                    label={intl.formatMessage({
                      defaultMessage: "Parent Content",
                      description: "Parent Content"
                    })}
                    fullWidth
                    rowsMax={10}
                    value={data.parentComment.text}
                  />
                  <FormSpacer />
                </CardContent>
              </Card>
            )}
            <FormSpacer />
            {data?.parentType !== "Comment" && (
              <InsCommentHistory
                history={insComment?.comments}
                onNoteAdd={btnComment}
              />
            )}
          </Grid>
        </Container>
      )}
    </Form>
  );
};

export default InsCommentDetailsPage;
